import { t } from "@lingui/macro";
import React from "react";

import { DropdownSelect } from "../../controls";
import { SubArrowIcon } from "../../icons_v2/general";
import { Box, HStack, VStack } from "../../primitive";
import { Text } from "../../primitive";
import { Avatar } from "../Avatar";

type UnknownGuestChargeRowProps = {
  unknownGuestDropdownOptions: { value: string; label: string }[];
  totalVariant?: "TOP" | "BOTTOM";
  unknownGuestCount?: number;
  onChangeUnknownGuests: (unknownGuestCount: string) => void;
  shouldShowPayForDropdown?: boolean;
  isPatronEventDisplay?: boolean;
  chargeName?: string;
  payerId: string;
};

export const UnknownGuestChargeRow = ({
  unknownGuestDropdownOptions,
  totalVariant,
  unknownGuestCount,
  onChangeUnknownGuests,
  shouldShowPayForDropdown,
  isPatronEventDisplay = false,
  chargeName,
  payerId,
}: UnknownGuestChargeRowProps) => {
  const isTotalVariantTop = totalVariant === "TOP";

  const name = t`Unknown Guest`;

  return (
    <HStack px={isTotalVariantTop ? 4 : 6} alignItems="center" py={1}>
      <Box mr={4}>
        <SubArrowIcon color={"main-primary-1000"} />
      </Box>

      <Avatar
        firstName={t`Unknown`}
        lastName={t`Guest`}
        type={"guest"}
        size="sm"
      />

      <VStack pl={4} flex={1}>
        <Text variant="mainBaseMedium">{name}</Text>
        {chargeName ? (
          <Text variant="mainSmallSemiBold" color="text-secondary">
            {chargeName}
          </Text>
        ) : null}
      </VStack>
      {!isPatronEventDisplay ? (
        <VStack flex={1} maxWidth="20%" alignItems="center" mt={3}>
          <DropdownSelect
            testID={`unknown-guest-count-select-${chargeName}-${payerId}`}
            options={unknownGuestDropdownOptions}
            value={unknownGuestCount ? `${unknownGuestCount}` : "0"}
            onChange={(v) => {
              if (v) {
                onChangeUnknownGuests(v);
              }
            }}
            size="tiny"
            isDisabled={!shouldShowPayForDropdown}
          />
        </VStack>
      ) : null}
    </HStack>
  );
};
